export const environment = {
  env: 'prd',

  apis: {
    auth: 'https://auth.mbpnetwork.com',
    cc: 'https://cc.mbpnetwork.com',
    portal: 'https://portal.mbpnetwork.com',
  },

  agencyLogoBaseUrl: 'assets/images/agent',
  dealerLogoBaseUrl: 'assets/images/dealer',
  profilePhotoBaseUrl: 'assets/images/user',
  noLogoUrl: 'assets/images/nologo.png',
  noAvatar: 'noavatar.png',

  notificationAppID: 'c32b4bf5-b981-4855-8539-2fbff677d6a6',

  ngxs: {
    logger: 'false',
    devTools: 'false',
  },

  logRocket: {
    on: 'true',
    appId: 'yinczu/mbpi-portal-ui',
  },

  routing: {
    enableTracing: false,
  },

  version: {
    url: 'version.json',
    frequency: 1000 * 60 * 10,
  },

  legacyHostName: 'secure.mbpnetwork.com',
};
